import { createGlobalStyle } from "styled-components";
import "./css/dashkit/border-color-override.scss";
import "./css/dashkit/flatpickr.min.css";
import "./css/dashkit/quill.core.css";
import "./css/dashkit/theme.min.css";
import "./css/dashkit/vs2015.css";
import "./css/tailwind/whitespace.css";
import "./scss/main.scss";
//import "@merge-api/merge-javascript-shared/src/designSystem/styles/design-system-styles.scss";
import "./css/tailwind/tailwind.css";
import { spectrum } from "./theme";

const GlobalStyle = createGlobalStyle`
:root {
    --gray0: ${spectrum.gray0};
    --gray10: ${spectrum.gray10};
    --gray20: ${spectrum.gray20};
    --gray30: ${spectrum.gray30};
    --gray40: ${spectrum.gray40};
    --gray50: ${spectrum.gray50};
    --gray60: ${spectrum.gray60};
    --gray70: ${spectrum.gray70};
    --gray80: ${spectrum.gray80};
    --gray90: ${spectrum.gray90};

    --red0: ${spectrum.red0};
    --red10: ${spectrum.red10};
    --red20: ${spectrum.red20};
    --red30: ${spectrum.red30};
    --red40: ${spectrum.red40};
    --red50: ${spectrum.red50};
    --red60: ${spectrum.red60};
    --red70: ${spectrum.red70};
    --red80: ${spectrum.red80};
    --red90: ${spectrum.red90};

    --yellow0: ${spectrum.yellow0};
    --yellow10: ${spectrum.yellow10};
    --yellow20: ${spectrum.yellow20};
    --yellow30: ${spectrum.yellow30};
    --yellow40: ${spectrum.yellow40};
    --yellow50: ${spectrum.yellow50};
    --yellow60: ${spectrum.yellow60};
    --yellow70: ${spectrum.yellow70};
    --yellow80: ${spectrum.yellow80};
    --yellow90: ${spectrum.yellow90};

    --orange0: ${spectrum.orange0};
    --orange10: ${spectrum.orange10};
    --orange20: ${spectrum.orange20};
    --orange30: ${spectrum.orange30};
    --orange40: ${spectrum.orange40};
    --orange50: ${spectrum.orange50};
    --orange60: ${spectrum.orange60};
    --orange70: ${spectrum.orange70};
    --orange80: ${spectrum.orange80};
    --orange90: ${spectrum.orange90};


    --green0: ${spectrum.green0};
    --green10: ${spectrum.green10};
    --green20: ${spectrum.green20};
    --green30: ${spectrum.green30};
    --green40: ${spectrum.green40};
    --green50: ${spectrum.green50};
    --green60: ${spectrum.green60};
    --green70: ${spectrum.green70};
    --green80: ${spectrum.green80};
    --green90: ${spectrum.green90};

    --teal0: ${spectrum.teal0};
    --teal10: ${spectrum.teal10};
    --teal20: ${spectrum.teal20};
    --teal30: ${spectrum.teal30};
    --teal40: ${spectrum.teal40};
    --teal50: ${spectrum.teal50};
    --teal60: ${spectrum.teal60};
    --teal70: ${spectrum.teal70};
    --teal80: ${spectrum.teal80};
    --teal90: ${spectrum.teal90};

    --blue0: ${spectrum.blue0};
    --blue10: ${spectrum.blue10};
    --blue20: ${spectrum.blue20};
    --blue30: ${spectrum.blue30};
    --blue40: ${spectrum.blue40};
    --blue50: ${spectrum.blue50};
    --blue60: ${spectrum.blue60};
    --blue70: ${spectrum.blue70};
    --blue80: ${spectrum.blue80};
    --blue90: ${spectrum.blue90};

    --purple0: ${spectrum.purple0};
    --purple10: ${spectrum.purple10};
    --purple20: ${spectrum.purple20};
    --purple30: ${spectrum.purple30};
    --purple40: ${spectrum.purple40};
    --purple50: ${spectrum.purple50};
    --purple60: ${spectrum.purple60};
    --purple70: ${spectrum.purple70};
    --purple80: ${spectrum.purple80};
    --purple90: ${spectrum.purple90};
  }
`;

export default GlobalStyle;
